(function () {
    'use strict';

    angular
        .module('app.completions')
        .factory('completionsDataService', completionsDataService);

    completionsDataService.$inject = ['dataservice', 'common'];
    /* @ngInject */
    function completionsDataService(dataservice, common) {
        var $q = common.$q;
        var cachedTaskCompletionTypes = null;
        var cachedBookingCompletionTypes = null;
        var cachedServiceOrderCompletionTypes = null;

        var service = {
            getCompletionTypesForItem: getCompletionTypesForItem,
            clearCache: clearCache,
            completeItem: completeItem,
            getLastCompletionForType: getLastCompletionForType,
            isAllDone: isAllDone,
            getIcs: getIcs

   
        };

        return service;

        function _multiLineNote(notes, padding) {
            var result = notes;
            
            result = result.replace(/\r\n/g, "\\n" + padding);
            result =  result.replace(/\r/g, "\\n" + padding);
            result = result.replace(/\n/g, "\\n" + padding);
           
            return result;
        }

        function getIcs(bookingData) {
            
            var ics = "";
            ics += "BEGIN:VCALENDAR\n";
            ics += "VERSION:2.0\n";
            ics += "PRODID:7PointOps.com\n";
            ics += "METHOD:PUBLISH\n";
            ics += "BEGIN:VEVENT\n";
            ics += "DTSTART:" + moment(bookingData.BuildingLocalEventStart).format('YYYYMMDDTHHmmss') + "\n";
            ics += "DTEND:" + moment(bookingData.BuildingLocalEventEnd).format('YYYYMMDDTHHmmss') + "\n";
            ics += "SUMMARY:" + bookingData.EventName + "\n";
            var bcDash = "";
            if (bookingData.BuildingCode) {
                bcDash = " - ";
            }
            ics += "LOCATION:" + bookingData.BuildingCode + bcDash + bookingData.RoomDescription + " - (" + bookingData.SetupType + ", " + bookingData.SetupCount + ")\n";

            var servicesText = "";
            
            for (var i = 0; i < bookingData.Services.length; i++) {
                if (i > 0) {
                    servicesText += "\\n";
                }
                var so = bookingData.Services[i];
                var sods = so.ServiceOrderDetails;
                
                
                switch (so.Category.ResourceCategoryTypeCode) {
                    case "CAT":
                        servicesText += so.Category.Description + " - " + so.ServiceType + " (" + so.EstimatedCount + ") from " + moment(so.TimeStart).format("LT") + " to " + moment(so.TimeEnd).format("LT") + "\\n";
                        for (var j = 0; j < sods.length; j++) {
                            var sod = sods[j];
                            servicesText += "     - " + sod.Quantity + " " + (sod.TempResourceDescription || ((sod.Resource && sod.Resource.Description) || "Bad Config - Missing Resource")) + "\\n";
                            if (sod.Groupings) {
                                for (var ii = 0; ii < sod.Groupings.length; ii++) {
                                    servicesText += "          -" + sod.Groupings[ii].Description + "\\n";
                                    for (var iii = 0; iii < sod.Groupings[ii].Items.length; iii++) {
                                        var gItem = sod.Groupings[ii].Items[iii];
                                        servicesText += "               -" + gItem.Description;
                                        if (gItem.Notes) {
                                            servicesText += " - " + _multiLineNote(gItem.Notes, "               ");
                                        }
                                        servicesText += "\\n";
                                    }
                                }
                            }
                            if (sod.Notes) {
                                servicesText += "     - " + _multiLineNote(sod.Notes, "     ") + "\\n";
                            }
                            if (sod.SpecialInstructions) {
                                servicesText += "     - " + _multiLineNote(sod.SpecialInstructions, "     ") + "\\n";
                            }
                        }

                        break;
                    case "RSO":
                        servicesText += so.Category.Description +" from " + moment(so.TimeStart).format("LT") + " to " + moment(so.TimeEnd).format("LT") + "\\n";
                        for (var rsoj = 0; rsoj < sods.length; rsoj++) {
                            var rsoSod = sods[rsoj];
                            servicesText += "     - " + rsoSod.Quantity + " " + (rsoSod.TempResourceDescription || ((rsoSod.Resource && rsoSod.Resource.Description) || "Bad Config - Missing Resource")) + "\\n";
                            if (rsoSod.Groupings) {
                                for (var rsoii = 0; rsoii < rsoSod.Groupings.length; rsoii++) {
                                    servicesText += "          -" + rsoSod.Groupings[rsoii].Description + "\\n";
                                    for (var rsoiii = 0; rsoiii < rsoSod.Groupings[rsoii].Items.length; rsoiii++) {
                                        var rsogItem = rsoSod.Groupings[rsoii].Items[rsoiii];
                                        servicesText += "               -" + rsogItem.Description;
                                        if (rsogItem.Notes) {
                                            servicesText += " - " + _multiLineNote(rsogItem.Notes, "               ");
                                        }
                                        servicesText += "\\n";
                                    }
                                }
                            }
                            if (rsoSod.Notes) {
                                servicesText += "     - " + _multiLineNote(rsoSod.Notes, "     ") + "\\n";
                            }
                            if (rsoSod.SpecialInstructions) {
                                servicesText += "     - " + _multiLineNote(rsoSod.SpecialInstructions, "     ") + "\\n";
                            }
                        }
                        
                        break;
                    case "RES":
                        servicesText += so.Category.Description + "\\n";
                        for (var resj = 0; resj < sods.length; resj++) {
                            var resSod = sods[resj];
                            servicesText += "     - " + resSod.Quantity + " " + (resSod.TempResourceDescription || ((resSod.Resource && resSod.Resource.Description) || "Bad Config - Missing Resource")) + "\\n";
                            if (resSod.Groupings) {
                                for (var resii = 0; resii < resSod.Groupings.length; resii++) {
                                    servicesText += "          -" + resSod.Groupings[resii].Description + "\\n";
                                    for (var resiii = 0; resiii < resSod.Groupings[resii].Items.length; resiii++) {
                                        var resgItem = resSod.Groupings[resii].Items[resiii];
                                        servicesText += "               -" + resgItem.Description;
                                        if (resgItem.Notes) {
                                            servicesText += " - " + _multiLineNote(resgItem.Notes, "               ");
                                        }
                                        servicesText += "\\n";
                                    }
                                }
                            }
                            if (resSod.Notes) {
                                servicesText += "     - " + _multiLineNote(resSod.Notes, "     ") + "\\n";
                            }
                            if (resSod.SpecialInstructions) {
                                servicesText += "     - " + _multiLineNote(resSod.SpecialInstructions, "     ") + "\\n";
                            }
                        }
                        
                        break;
                    case "ACT":
                        servicesText += so.Category.Description + "\\n";
                        for (var actj = 0; actj < so.ServiceOrderDetails.length; actj++) {
                            var actsod = so.ServiceOrderDetails[actj];
                            servicesText += "     " + moment(actsod.TimeStart).format("LT");
                            if (actsod.TimeEnd) {
                                servicesText += " - " + moment(actsod.TimeEnd).format("LT");
                            }
                            servicesText += " " + actsod.TempResourceDescription + "\\n";
                            if (actsod.Notes) {
                                servicesText += "          " + _multiLineNote(actsod.Notes, "          ") + "\\n";
                            }
                            
                        }
                        break;
                    case "ATT":
                        servicesText += so.Category.Description + "\\n";
                        for (var attI = 0; attI < so.ServiceOrderDetails.length; attI++) {
                            var attISod = so.ServiceOrderDetails[attI];
                            servicesText += attISod.TempResourceDescription;
                            if (attISod.EmailAddress) {
                                servicesText += " - " + attISod.EmailAddress;
                            }

                            if (attISod.Phone) {
                                servicesText += " - " + attISod.Phone;
                            }

                            servicesText += "\\n";
                            if (attISod.Notes) {
                                servicesText += "     " + _multiLineNote(attISod.Notes, "     ") + "\\n";
                            }
                            if (attISod.SpecialInstructions) {
                                servicesText += "     " + _multiLineNote(attISod.SpecialInstructions, "     ") + "\\n";
                            }
                            
                        }

                        break;
                    case "NOT":
                        servicesText += so.Category.Description + "\\n";
                        for (var notI = 0; notI < so.ServiceOrderDetails.length; notI++) {
                            var notISod = so.ServiceOrderDetails[notI];
                            servicesText += "     " + _multiLineNote(notISod.Notes, "     ") + "\\n";
                        }

                        break;
                }
                
                
            }
            
            ics += "DESCRIPTION: " + servicesText + "\n";
          
            ics += "PRIORITY:3" + "\n";
            ics += "END:VEVENT" + "\n";

            ics += "END:VCALENDAR";

            
            var linkElement = document.createElement('a');
            try {
                var blob = new Blob([ics], { type: 'text/ics' });
                var url = window.URL.createObjectURL(blob);

                linkElement.setAttribute('href', url);
                linkElement.setAttribute("download", bookingData.EventName + ".ics");

                var clickEvent = new MouseEvent("click", {
                    "view": window,
                    "bubbles": true,
                    "cancelable": false
                });
                linkElement.dispatchEvent(clickEvent);
            } catch (ex) {
                console.log(ex);
            }

        }

        function _isCompletionType(completionTypeId) {
            return function (element) {
                return element.CompletionTypeId == completionTypeId;
            }
        }

        function getLastCompletionForType(completionTypeId, item) {
            if (item && item.Completions) {
                var completions = item.Completions.filter(_isCompletionType(completionTypeId));
                completions.sort(function (a, b) {
                    a = new Date(a.DateAddedUtc);
                    b = new Date(b.DateAddedUtc);
                    return a > b ? -1 : a < b ? 1 : 0
                });
                return completions[0];
            }
            return null;
        }

        function isAllDone(item) {
            var allDoneTypeId = 0;
            for (var i = 0; i < item.Completions.length; i++) {
                if (item.Completions[i].IsAllDoneType) {
                    allDoneTypeId = item.Completions[i].CompletionTypeId;
                    break;
                }
            }
            
            var com = getLastCompletionForType(allDoneTypeId, item);
            if (com) {
                if (com.CompletedAtUtc != null) {
                    return true;
                }
            }
            return false;
        }


        function completeItem(completionTypeId, item) {
            
            var completion = getLastCompletionForType(completionTypeId, item);
            var isComplete = false;
            if (completion) {
                if (completion.CompletedAtUtc == null) {
                    isComplete = true;
                }
            }
            else {
                isComplete = true;
            }

            var completionDto = {};
            completionDto.BookingId = item.BookingId;
            completionDto.TaskId = item.TaskId;
            completionDto.ServiceOrderId = item.ID;
            completionDto.IsComplete = isComplete;
            completionDto.CompletionTypeId = completionTypeId;
            completionDto.DisplayedOn = moment(common.getMainState("mainDate")).format("YYYYMMDD");
            dataservice.saveItem('api/DailySetup/NewCompletion', completionDto).then(function (saveResult) {
                common.notifier.notify(common.config.events.refreshCounts);
            }).catch(function (error) {
            });
        }




        function clearCache() {
            cachedTaskCompletionTypes = null;
            cachedBookingCompletionTypes = null;
            cachedServiceOrderCompletionTypes = null;
        }

        function _sorter(a, b) {
            var s1 = Number(a.Sequence);
            var s2 = Number(b.Sequence);

            var s3 = a.Description;
            var s4 = b.Description;

            if (s1 < s2) return -1;
            if (s1 > s2) return 1;
            if (s3 < s4) return -1;
            if (s3 > s4) return 1;
            return 0;
        }

        function getCompletionTypesForItem(item) {
            
            var path = 'api/CompletionTypes/';
            var typesForItem = 0;
          
            if (item.TaskId > 0) {
                path += 'GetForTask';
                typesForItem = 0;
                if (cachedTaskCompletionTypes !== null) {
                    return $q.resolve(cachedTaskCompletionTypes);
                }
            }
            else if (item.ID) {
                path += 'GetForServiceOrder';
                typesForItem = 1;
                if (cachedServiceOrderCompletionTypes !== null) {
                    return $q.resolve(cachedServiceOrderCompletionTypes);
                }
            }
            else {
                path += 'GetForBooking';
                typesForItem = 2;
                if (cachedBookingCompletionTypes !== null) {
                    return $q.resolve(cachedBookingCompletionTypes);
                }
            }

            return dataservice.getItems(path).then(function (response) {
                if (typesForItem == 2) {
                    cachedBookingCompletionTypes = response.data;
                    cachedBookingCompletionTypes.sort(_sorter);
                    return $q.resolve(cachedBookingCompletionTypes);
                }
                else if (typesForItem == 1) {
                    cachedServiceOrderCompletionTypes = response.data;
                    cachedServiceOrderCompletionTypes.sort(_sorter);
                    return $q.resolve(cachedServiceOrderCompletionTypes);
                }
                else {
                    cachedTaskCompletionTypes = response.data;
                    cachedTaskCompletionTypes.sort(_sorter);
                    return $q.resolve(cachedTaskCompletionTypes);
                }
            }, function (error) { });
        }
    }
}());
